export default "__VITE_ASSET__E6SoRpoN__"